<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Receive Purchase Order Assets">
        <b-button
          type="button"
          variant="primary"
          class="mr-1"
          @click="previous()"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            size="16"
            class="align-middle"
          />
          Back
        </b-button>
        <b-form @submit.prevent="submitReceivePurchaseOrder">
          <b-row
            v-for="(item, index) in items"
            :key="index"
          >
            <b-col cols="12">
              <hr>
              <h3>( {{ index + 1 }} ) {{ item.item.item_code }}</h3>
              <br>
              <b-form-group
                label="Item ID "
                label-for="itemId"
                label-cols-md="12"
              >
                <b-form-input
                  :value="item.item.item_code"
                  placeholder="itemId"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label-for="assetRefId"
                label-cols-md="12"
              >
                <template #label>
Asset Ref ID <span style="color:red">*</span>
</template>
                <b-form-input
                  v-model="item.asset_ref_id"
                  placeholder="Asset Ref Id"
                  required
                />
              </b-form-group>
              <b-form-group
                label="Asset Local ID "
                label-for="assetLocalId"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_local_id"
                  placeholder="Asset Local Id"
                />
              </b-form-group>
              <b-form-group
                label-for="category"
                label-cols-md="12"
              >
                <template #label>
Group Asset <span style="color:red">*</span>
</template>
                <v-select-new
                  v-model="item.asset_category"
                  :options="categories"
                  :class="{ 'is-invalid-select': item._errors && item._errors.asset_category }"
                />
                <div
v-if="item._errors && item._errors.asset_category"
style="color:#dc3545;font-size:0.857rem;margin-top:0.25rem;"
>
                  {{ item._errors.asset_category }}
                </div>
              </b-form-group>
              <b-form-group
                label-for="description"
                label-cols-md="12"
              >
                <template #label>
Description <span style="color:red">*</span>
</template>
                <b-form-input
                  v-model="item.asset_description"
                  placeholder="Asset Description"
                  required
                />
              </b-form-group>
              <b-form-group
                label="Note"
                label-for="description"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_note"
                  placeholder="Asset Note"
                />
              </b-form-group>
              <b-form-group
                label="GPS"
                label-for="gps"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_gps"
                  placeholder="Asset GPS"
                />
              </b-form-group>
              <b-form-group
                label-cols-md="12"
              >
                <template #label>
Date of Acquisition <span style="color:red">*</span>
</template>
                <b-form-datepicker
                  v-model="item.asset_date_of_acquistion"
                  placeholder="Asset Date of Acquisition"
                  required
                />
              </b-form-group>
              <b-form-group
                label-cols-md="12"
              >
                <template #label>
                  <span>Acquisition Value <span style="color:red">*</span></span>
                </template>
                <input
                  v-model="item.asset_acquistion_value"
                  placeholder="Angka saja, contoh: 15000000"
                  inputmode="numeric"
                  class="form-control"
                  :class="{ 'is-invalid': item._errors && item._errors.asset_acquistion_value }"
                  @input="filterItemNumeric(item, 'asset_acquistion_value', $event)"
                >
                <div
v-if="item._errors && item._errors.asset_acquistion_value"
class="invalid-feedback"
>
                  {{ item._errors.asset_acquistion_value }}
                </div>
              </b-form-group>
              <b-form-group
                label="Depreciation Method"
                label-for="assetDepreciationMethod"
                label-cols-md="12"
              >
                <v-select-new
                  v-model="item.asset_depreciation_method"
                  :options="methods"
                />
              </b-form-group>
              <b-form-group
                label="Residual Value"
                label-for="assetResidualValue"
                label-cols-md="12"
              >
                <input
                  v-model="item.asset_residual_value"
                  placeholder="Angka saja, contoh: 1000000"
                  inputmode="numeric"
                  class="form-control"
                  @input="filterItemNumeric(item, 'asset_residual_value', $event)"
                >
              </b-form-group>
              <b-form-group
                label="Market Value"
                label-for="assetMarketValue"
                label-cols-md="12"
              >
                <input
                  v-model="item.asset_market_value"
                  placeholder="Angka saja, contoh: 12000000"
                  inputmode="numeric"
                  class="form-control"
                  @input="filterItemNumeric(item, 'asset_market_value', $event)"
                >
              </b-form-group>
              <b-form-group
                label-for="assetAssetCondition"
                label-cols-md="12"
              >
                <template #label>
Asset Condition <span style="color:red">*</span>
</template>
                <v-select-new
                  v-model="item.asset_condition"
                  :options="conditions"
                  :class="{ 'is-invalid-select': item._errors && item._errors.asset_condition }"
                />
                <div
v-if="item._errors && item._errors.asset_condition"
style="color:#dc3545;font-size:0.857rem;margin-top:0.25rem;"
>
                  {{ item._errors.asset_condition }}
                </div>
              </b-form-group>
              <b-form-group
                label="Asset Address"
                label-for="assetAddress"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_address"
                  placeholder="Asset Address"
                />
              </b-form-group>
              <b-form-group
                label-for="assetResponsible"
                label-cols-md="12"
              >
                <template #label>
Asset Responsible <span style="color:red">*</span>
</template>
                <b-form-input
                  v-model="item.asset_responsible"
                  placeholder="Asset Responsible"
                  required
                />
              </b-form-group>
              <b-form-group
                label="Serial Number"
                label-for="assetSerialNumber"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_serial_no"
                  placeholder="Asset Serial Number"
                />
              </b-form-group>
              <b-form-group
                label="Warranty"
                label-for="assetWarranty"
                label-cols-md="12"
              >
                <b-form-input
                  v-model="item.asset_warranty"
                  placeholder="Asset Warranty"
                />
              </b-form-group>
              <b-form-group
                label="Document"
                label-for="assetDocument"
                label-cols-md="12"
              >
                <b-form-file
                  v-model="item.document_file"
                  placeholder="Choose one or more files or drop it here..."
                  drop-placeholder="Drop files here..."
                />
              </b-form-group>
              <b-form-group
                label="Photo"
                label-for="assetPhoto"
                label-cols-md="12"
              >
                <b-form-file
                  v-model="item.photo_file"
                  accept="image/*"
                  placeholder="Choose one image file (jpg/png) or drop it here."
                  drop-placeholder="Drop an image here..."
                  @input="compressPhoto(item, $event)"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-button
            type="submit"
            variant="primary"
            :disabled="submitButtonDisabled"
            class="mt-2"
          >
            Submit
          </b-button>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormDatepicker,
  BFormFile,
} from "bootstrap-vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "axios"
import moment from "moment-timezone"
import Ripple from "vue-ripple-directive"
import vSelectNew from "vue-select"
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BFormFile,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelectNew,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      categories: ["Machinery (MC)", "Furniture & Fixture", "Office Equipment", "Lab Equipment", "Vehicle (VH)", "Building", "Software", "Low Value Asset", "Land", "Field Equipment"],
      methods: ["Metode Garis Lurus", "Metode Saldo Menurun", "Metode Unit Produksi", "Metode Jam Kerja", "Metode Penyusutan Akselerasi"],
      conditions: ["Baik", "Sedang", "Buruk"],
      submitButtonDisabled: false,
    }
  },
  mounted() {
    this.getDetails()
  },
  created() {
    window.setInterval(() => {
      this.removeReadOnly()
    }, 1000)
  },
  methods: {
    removeReadOnly() {
      const searches = document.getElementsByClassName("vs__search")
      for (let i = 0; i < searches.length; i += 1) {
        searches[i].removeAttribute("readonly")
      }
    },
    getDetails() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const itemReceive = JSON.parse(localStorage.getItem("AssetReceiveDetail"))
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_PURCHASE_ORDER_RECEIVE_ASSET_CHECK}${itemReceive.purchase_order_purchasing_receive.purchase_order_purchasing_receive_id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const temp = []
            response.data.data.forEach(elem => {
              // Use item_requested (qty ordered) — item_received may be null before warehouse confirms
              const tempNum = parseInt(elem.purchase_order_purchasing_receive_detail_item_requested) || 0
              for (let i = 0; i < tempNum; i += 1) {
                temp.push({
                  itemId: elem.item.item_id,
                  label: `${elem.item.item_name} (${elem.item.item_code}) (QTY : ${elem.purchase_order_purchasing_receive_detail_item_requested})`,
                  unit: elem.item.unit ? elem.item.unit.unit_name : '-',
                  name: elem.item.item_name,
                  value: elem.purchase_order_purchasing_receive_detail_id,
                  asset_id: '',
                  received: elem.purchase_order_warehouse_receive_detail_item_received,
                  max: tempNum,
                  item: elem.item,
                  checked: false,
                  shelves: elem.shelves,
                  asset_depreciation_method: "Metode Garis Lurus",
                  id: temp.length + 1,
                })
              }
            })
            this.items = temp
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    submitReceivePurchaseOrder() {
      if (!this.validateItems()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Harap lengkapi semua field yang wajib diisi.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.submitButtonDisabled = true
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      }

      const item = JSON.parse(localStorage.getItem("AssetReceiveDetail"))
      const itemReceive = JSON.parse(localStorage.getItem("AssetReceiveDetail"))

      // FIX: Ensure totalReceived is sent dynamically based on the number of generated assets instead of 0
      const totalReceived = this.items.length
      const id = item.purchase_order_warehouse_receive_id

      const formData = new FormData()
      // Strip out File objects before JSON-serialising (they can't be stringified)
      const itemsForJson = this.items.map(i => {
        const { photo_file, document_file, ...rest } = i
        return rest
      })
      formData.append("receive_items", JSON.stringify(itemsForJson))
      formData.append("purchase_order_purchasing_receive_id", itemReceive.purchase_order_warehouse_receive_purchasing_receive_id)
      formData.append("purchase_order_warehouse_receive_total_received", totalReceived)
      formData.append("time", moment())

      // Append photo and document files per item index
      this.items.forEach((itm, idx) => {
        if (itm.photo_file) {
          formData.append(`photo_${idx}`, itm.photo_file)
        }
        if (itm.document_file) {
          formData.append(`document_${idx}`, itm.document_file)
        }
      })
      formData.append("total_items", this.items.length)

      const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_RECEIVE_ASSET_PURCHASE_ORDER}${id}`
      axios
        .post(url, formData, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.submitButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Receive Purchase Order Assets Success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
            this.$router.replace({
              name: 'apps-assets-receive-list',
            })
          } else {
            this.submitButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Receive Purchase Order Assets Failed",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
          }
        })
        .catch(e => {
          this.submitButtonDisabled = false
          const msg = e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : "Receive Purchase Order Asset Failed"
          this.$toast({
            component: ToastificationContent,
            props: {
              title: msg,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          })
        })
    },
    previous() {
      this.$router.push({ name: 'apps-assets-receive-list' })
    },

    // Resize + compress an image File using canvas, returns a JPEG File.
    // Falls back to the original file if compression doesn't help or fails.
    resizeAndCompressImage(file, maxDimension = 1600, quality = 0.75) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = e => {
          const img = new Image()
          img.onload = () => {
            let { width, height } = img
            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = Math.round((height * maxDimension) / width)
                width = maxDimension
              } else {
                width = Math.round((width * maxDimension) / height)
                height = maxDimension
              }
            }
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d').drawImage(img, 0, 0, width, height)
            canvas.toBlob(blob => {
              if (!blob) {
                resolve(file)
                return
              }
              const compressedFile = new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() })
              resolve(compressedFile.size < file.size ? compressedFile : file)
            }, 'image/jpeg', quality)
          }
          img.onerror = () => resolve(file)
          img.src = e.target.result
        }
        reader.onerror = () => resolve(file)
        reader.readAsDataURL(file)
      })
    },

    // Triggered when user picks a Photo file - compresses it before it's stored on the item
    async compressPhoto(item, file) {
      if (!file || !file.type || !file.type.startsWith('image/')) return
      try {
        const compressed = await this.resizeAndCompressImage(file)
        this.$set(item, 'photo_file', compressed)
      } catch (e) {

      }
    },

    filterItemNumeric(item, field, event) {
      const raw = event.target.value || ''
      const cleaned = raw.replace(/[.,]/g, '').replace(/[^0-9]/g, '')
      this.$set(item, field, cleaned)
      if (item._errors) this.$delete(item._errors, field)
    },

    validateItems() {
      let valid = true
      const REQUIRED = [
        { key: 'asset_ref_id', label: 'Asset Ref ID' },
        { key: 'asset_category', label: 'Group Asset' },
        { key: 'asset_description', label: 'Description' },
        { key: 'asset_date_of_acquistion', label: 'Date of Acquisition' },
        { key: 'asset_acquistion_value', label: 'Acquisition Value' },
        { key: 'asset_condition', label: 'Asset Condition' },
        { key: 'asset_responsible', label: 'Asset Responsible' },
      ]
      this.items.forEach((item, idx) => {
        const errors = {}
        REQUIRED.forEach(({ key, label }) => {
          const val = item[key]
          if (val === null || val === undefined || String(val).trim() === '') {
            errors[key] = `${label} wajib diisi.`
          }
        })
        // Extra: acquisition value must be numeric
        if (item.asset_acquistion_value && !/^\d+$/.test(String(item.asset_acquistion_value))) {
          errors.asset_acquistion_value = 'Hanya angka yang diperbolehkan.'
        }
        this.$set(this.items[idx], '_errors', errors)
        if (Object.keys(errors).length > 0) valid = false
      })
      return valid
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
